"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Returns page meta data
 * @param {object} data
 * @returns {object}
 */
function getMetaData(data) {
  var description = (0, _get2["default"])(data, 'metaDescription', '');
  var title = (0, _get2["default"])(data, 'metaTitle', '');
  var pageHeading = (0, _get2["default"])(data, 'pageHeading', '');
  var pageSubheading = (0, _get2["default"])(data, 'pageSubheading', '');
  return {
    description: description,
    title: title,
    pageHeading: pageHeading,
    pageSubheading: pageSubheading
  };
}
var _default = exports["default"] = getMetaData;